import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const packageApi = createApi({
    reducerPath: 'packageApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/admin`,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['Packages'],
    endpoints: (build) => ({
        getPackages: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return `/packages/${qs ? `?${qs}` : ''}`;
            },
            providesTags: ['Packages'],
        }),
        /* One package, active or not, for the package editor page. */
        getPackage: build.query({
            query: (id) => `/packages/${id}`,
            providesTags: ['Packages'],
        }),
        createPackage: build.mutation({
            query: (data) => ({ url: '/packages/', method: 'POST', body: data }),
            invalidatesTags: ['Packages'],
        }),
        updatePackage: build.mutation({
            query: ({ id, data }) => ({ url: `/packages/${id}`, method: 'PUT', body: data }),
            invalidatesTags: ['Packages'],
        }),
        deletePackage: build.mutation({
            query: (id) => ({ url: `/packages/${id}`, method: 'DELETE' }),
            invalidatesTags: ['Packages'],
        }),
        addPackageFeature: build.mutation({
            query: ({ packageId, data }) => ({ url: `/packages/${packageId}/features`, method: 'POST', body: data }),
            invalidatesTags: ['Packages'],
        }),
        updatePackageFeature: build.mutation({
            query: ({ featureId, data }) => ({ url: `/packages/features/${featureId}`, method: 'PUT', body: data }),
            invalidatesTags: ['Packages'],
        }),
        deletePackageFeature: build.mutation({
            query: (featureId) => ({ url: `/packages/features/${featureId}`, method: 'DELETE' }),
            invalidatesTags: ['Packages'],
        }),
    }),
});

export const {
    useGetPackagesQuery,
    useGetPackageQuery,
    useCreatePackageMutation,
    useUpdatePackageMutation,
    useDeletePackageMutation,
    useAddPackageFeatureMutation,
    useUpdatePackageFeatureMutation,
    useDeletePackageFeatureMutation,
} = packageApi;
